import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import ListarIncidentes from "./listar-incidentes";
import EstadoIncidente from "./estado-incidente";
import ListarEstadosIncidente from "./listar-estados-incidente";
import ListarSubEstadosIncidente from "./listar-sub-estados-incidente";
import SubEstadoIncidente from "./sub-estado-incidente";
import DetalleIncidentePage from "./detalle-incidente";

const RouterIncidente = () => {
  const { path } = useRouteMatch();
  // console.log('routerAdministracion');
  // console.log(path);
  return (
    // <LayoutConfiguracion>
    <Switch>

      <Route exact path={`${path}/listar-incidentes`}>
        <ListarIncidentes />
      </Route>
      <Route exact path={`${path}/listar-estados-incidente`}>
        <ListarEstadosIncidente />
      </Route>
      <Route exact path={`${path}/listar-sub-estados-incidente`}>
        <ListarSubEstadosIncidente />
      </Route>
      <Route exact path={`${path}/sub-estado-incidente`}>
        <SubEstadoIncidente />
      </Route>
      <Route exact path={`${path}/estado-incidente`}>
        <EstadoIncidente />
      </Route>

      <Route exact path={`${path}/detalle-incidente`}>
        <DetalleIncidentePage />
      </Route>

      {/* <Route exact path={`${path}`}>
        <AdministracionIndex />
      </Route> */}

    </Switch>
    // </LayoutConfiguracion>
  );
};

export default RouterIncidente;
